<template>
  <div id="ChildSeat">
    <!-- <img src="@/assets/img.jpg" class="img" /> -->
    <!-- 输入框的卡片 -->
    <div class="card">
      <div class="card-title">请输入设备编号</div>
      <el-form :rules="rules" ref="ruleForm" :model="form" label-width="100px">
        <el-form-item label="输入编号" prop="number1" class="form_item">
          <el-input
            v-model="form.number1"
            placeholder="请输入编号"
            class="Input"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认编号" prop="number2" class="form_item">
          <el-input
            v-model="form.number2"
            placeholder="请确认编号"
            class="Input"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="card-foter">免费领取启动时长</div>

      <el-button type="primary" plain medium @click="submitForm"
        >确定</el-button
      >
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="dialogMessage"
      :show-close="false"
    >
      <span>{{ message }}</span>
    </el-dialog>
    <!-- 性别男女的弹窗 -->
    <el-dialog
      title="请选择性别"
      :visible.sync="sexDialog"
      :before-close="closeSexDialog"
    >
      <el-radio-group v-model="radio">
        <el-radio :label="0">男</el-radio>
        <el-radio :label="1">女</el-radio>
      </el-radio-group>
      <div slot="footer">
        <!-- <el-button @click="sexDialog = false">取 消</el-button> -->
        <el-button type="primary" @click="confirmSex">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ChildSeat",
  components: {},
  data() {
    const validateNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("编号不能为空"));
      }
      // 正则表达式匹配5位数字
      const isNum = /^\d{1,5}$/;
      if (!isNum.test(value)) {
        return callback(new Error("请输入左侧二维码下方长度为1-5位的编号"));
      }
      return callback();
    };
    return {
      V1: undefined,
      dialogVisible: false,
      // 弹窗消息提示
      message: undefined,
      // 表单参数
      form: { number1: undefined, number2: undefined },
      rules: {
        number1: [
          { required: true, validator: validateNumber, trigger: "blur" },
        ],
        number2: [
          { required: true, validator: validateNumber, trigger: "blur" },
        ],
      },
      sexDialog: false, // 性别选择弹窗
      radio: 3, // 单选0男1女
    };
  },
  created() {
    this.uuid_sign(); // 确保 V1 已初始化
    this.getNums(); // 调用记录网站打开次数的方法
  },
  methods: {
    uuid_sign() {
      let preId = localStorage.getItem("ID");
      if (preId) {
        this.V1 = preId;
      } else {
        const ID = require("uuid");
        this.V1 = ID.v1();
        localStorage.setItem("ID", this.V1);
      }
    },
    // 记录网站打开次数
    getNums() {
      axios({
        method: "get",
        url: "https://zxwl.uzxkj.com/advertisement/pv_uv/",
        params: {
          app_id: this.V1,
          type_data: "3",
        },
      }).then((res) => {
        console.log("111", res);
      });
    },

    submitForm() {
      if (this.form.number1 != this.form.number2) {
        this.dialogVisible = true;
        this.message = "两次输入编号不一致！";
        if (this.dialogVisible) {
          setTimeout(() => {
            this.dialogVisible = false;
          }, 2000);
        }
      } else {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            axios({
              method: "get",
              url: "https://zxwl.uzxkj.com/advertisement/user_equ/",
              params: {
                app_id: this.V1,
                equipment_no: this.form.number1,
                type_data: "3",
              },
            })
              .then((res) => {
                //  启动失败
                if (res.data.code == -1) {
                  this.dialogVisible = true;
                  this.message = res.data.msg;
                  if (this.dialogVisible) {
                    setTimeout(() => {
                      this.dialogVisible = false;
                    }, 2000);
                  }
                } else if (res.data.code == 0) {
                  //  启动成功
                  this.dialogVisible = true;
                  this.message = res.data.msg;
                  setTimeout(() => {
                    this.dialogVisible = false;
                  }, 2000);
                }
              })
              .catch(() => {})
              .finally(() => {});
          }
        });
      }
    },
    closeSexDialog() {
      this.dialogVisible = false;
      // 确保焦点不会留在隐藏的元素上
      document.activeElement.blur();
    },
    // 确定性别的提交
    confirmSex() {
      // this.sexDialog = false;
      // console.log(this.radio);
      // this.dialogVisible = true;
      // this.message = "领取成功！";
      // if (this.dialogVisible) {
      //   setTimeout(() => {
      //     this.dialogVisible = false;
      //     this.$router.push({ path: "/ChildSeatD" });
      //   }, 2000);
      // }
    },
  },
};
</script>

<style scoped>
/* 全局或组件内添加 */
::v-deep .el-radio__original[aria-hidden="true"] {
  display: none !important;
}
#ChildSeat {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: rgb(187, 223, 142);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("@/assets/img.jpg");
  background-size: 74vh 50vh;
  background-repeat: no-repeat;
  height: 100vh;
}
.img {
  /* width: 80vw; */
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.form_item .el-form-item__content {
  margin-left: 0;
}
.Input {
  width: 14rem;
  right: 1rem;
}
.card {
  width: 89vw;
  background-color: #fff;
  text-align: center;
  margin-top: 39vh;
  height: 56vh;
  border-radius: 1%;
  padding-top: 2vh;
}
.card-title {
  margin-bottom: 3vh;
  padding-right: 26vh;
  font-size: 14px;
}
.card-foter {
  margin-bottom: 3vh;
  padding-right: 22vh;
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .Input .el-input__inner {
    width: 14rem;
  }
  .el-form-item__error {
    margin-left: 20px;
  }
  .dialogMessage {
    margin-top: 47vh !important;
    width: 78% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
  }
}
</style>
